export default "__VITE_ASSET__DpcAtmMJ__"